// removed by extract-text-webpack-plugin
module.exports = {"dropzone":"_3O1XkLZ992cH01gutYsPXb","activeDropzone":"bDlSU1saK-nQbQu212uVN","rejectDropzone":"_1fuYsag0xBRtJhX8Gjvmcp","button":"_1Rhft8GIe8cY_IINHQSsGd","helpButton":"_1vTO3OFlwVR3qPGR382MKK"};


//////////////////
// WEBPACK FOOTER
// ./src/Components/RegisterParticipants/RegisterParticipants.css
// module id = 734
// module chunks = 3